document.addEventListener('DOMContentLoaded', function () {
  const CHAT_SELECTOR = '#ShopifyChat';
  const MAX_ATTEMPTS = 30;
  const INTERVAL_DELAY = 500;

  let attempts = 0;
  let positionScheduled = false;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isProductPage() {
    return (
      document.body.classList.contains('template-product') ||
      document.documentElement.classList.contains('template-product')
    );
  }

  function getShopifyChat() {
    return document.querySelector(CHAT_SELECTOR);
  }

  function styleShopifyChatButton() {
    const shopifyChat = getShopifyChat();

    if (!shopifyChat || !shopifyChat.shadowRoot) {
      return false;
    }

    if (shopifyChat.shadowRoot.querySelector('#db-shopify-chat-style')) {
      return true;
    }

    const style = document.createElement('style');
    style.id = 'db-shopify-chat-style';

    style.textContent = `
      button.chat-toggle {
        width: 45px !important;
        height: 45px !important;
        min-width: 45px !important;
        min-height: 45px !important;
        max-width: 45px !important;
        max-height: 45px !important;
        padding: 0 !important;
      }

      button.chat-toggle svg {
        width: 45px !important;
        height: 45px !important;
        max-width: 45px !important;
        max-height: 45px !important;
      }
    `;

    shopifyChat.shadowRoot.appendChild(style);

    return true;
  }

  function positionShopifyChat() {
    const shopifyChat = getShopifyChat();

    if (!shopifyChat) {
      return false;
    }

    const isOpen = shopifyChat.getAttribute('is-open') === 'true';

    /*
      Quando la chat è aperta, lasciamo gestire a Shopify il pannello.
    */
    if (isOpen) {
      return true;
    }

    const desiredBottom = isMobile() && isProductPage() ? '60px' : '15px';
    const currentBottom = shopifyChat.style.getPropertyValue('bottom');

    /*
      Evita di riscrivere lo style se è già corretto.
      Questo riduce loop e mutation inutili.
    */
    if (currentBottom !== desiredBottom) {
      shopifyChat.style.setProperty('bottom', desiredBottom, 'important');
    }

    return true;
  }

  function schedulePositionShopifyChat() {
    if (positionScheduled) {
      return;
    }

    positionScheduled = true;

    window.requestAnimationFrame(function () {
      positionScheduled = false;
      positionShopifyChat();
    });
  }

  function observeShopifyChat() {
    const shopifyChat = getShopifyChat();

    if (!shopifyChat) {
      return false;
    }

    if (shopifyChat.dataset.dbObserved === 'true') {
      return true;
    }

    shopifyChat.dataset.dbObserved = 'true';

    const observer = new MutationObserver(function () {
      schedulePositionShopifyChat();
    });

    /*
      Non osserviamo "style", perché lo modifichiamo noi.
      Osserviamo solo apertura/chiusura chat.
    */
    observer.observe(shopifyChat, {
      attributes: true,
      attributeFilter: ['is-open']
    });

    return true;
  }

  function initShopifyChat() {
    const styled = styleShopifyChatButton();
    const positioned = positionShopifyChat();
    const observed = observeShopifyChat();

    return styled && positioned && observed;
  }

  const interval = setInterval(function () {
    attempts++;

    const initialized = initShopifyChat();

    if (initialized || attempts >= MAX_ATTEMPTS) {
      clearInterval(interval);
    }
  }, INTERVAL_DELAY);

  window.addEventListener('resize', schedulePositionShopifyChat);

  window.addEventListener('orientationchange', function () {
    setTimeout(schedulePositionShopifyChat, 300);
  });
});